export function debounce<T extends CallableFunction>(cb: T, wait = 20) {
  let h = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const callable = (...args: any) => {
    clearTimeout(h);
    h = window.setTimeout(() => cb(...args), wait);
  };
  return callable as unknown as T;
}
